import {NgModule} from '@angular/core';
import {Route, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {RegistrationComponent} from './registration/registration.component';
import {ConnectHomeComponent} from './home/connect-home.component';
import {AuthGuardService} from './common/auth-guard.service';
import {ConnectActivationComponent} from './activation/connect-activation.component';
import {ConnectSharedDocsComponent} from './shared-docs/connect-shared-docs.component';
import {ConnectCirfClientListComponent} from "./cirf/list/connect-cirf-client-list.component";
import {ConnectCirfComponent} from "./cirf/form/connect-cirf.component";
import {ConnectHomeListComponent} from "./home/connect-home-list.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {AcceptTermsConditionsComponent} from './accept-terms-conditions/accept-terms-conditions.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {MatterPropertyInfoComponent} from "./cirf/matter-property-info-form/matter-property-info-component";
import {MortgageFormComponent} from "./cirf/mortgage-form/mortgage-form.component";
import {PrintCirfComponent} from "./cirf/print-cirf/print-cirf.component";
import {ReferralFormComponent} from "./referral/referral-form.component";
import {MatterSummaryComponent} from './matter-summary/matter-summary.component';
import {CirfHomeComponent} from "./cirf/cirf-home.component";
import {MatterSummaryHomeComponent} from "./matter-summary/matter-summary-home.component";
import {MyCredentialsComponent} from "./my-credentials/my-credentials.component";


// default route of dppm app.
const indexRoute: Route = {
    path: '', redirectTo: 'home', pathMatch: 'full'
};

// when no matching url.
const fallbackRoute: Route = {
    path: '**', redirectTo: 'home', pathMatch: 'full'
}

const routes: Routes = [
    {path: '', redirectTo: 'login', pathMatch: 'full'},
    {path: 'login', component: LoginComponent},
    {path: 'accept-terms-conditions', component: AcceptTermsConditionsComponent},
    {path: 'register', component: RegistrationComponent},
    {path: 'forgot-password', component: ForgotPasswordComponent},
    {path: 'reset-password/:token', component: ResetPasswordComponent},
    {path: 'setup-password', component: ResetPasswordComponent},
    {path: 'activate/:token', component: ConnectActivationComponent},
    {
        path: 'home', data: {
        breadcrumb: {
            label: 'Home'

        }
    }, component: ConnectHomeComponent, canActivate: [AuthGuardService],
        children: [
            {path: '', redirectTo: 'connect-list', pathMatch: 'full'},
            {
                path: 'connect-list',
                data: {breadcrumb: {skip: true}}, component: ConnectHomeListComponent
            },
            {
                path: 'matter-summary-home', data: {
                breadcrumb: {label : 'File Summary',alias: 'MatterSummary'} ,
                } , component: MatterSummaryHomeComponent,
                children: [
                    {path: '', redirectTo: 'matter-summary', pathMatch: 'full'},
                    {
                        path: 'matter-summary',data: {breadcrumb: {skip: true}}, component: MatterSummaryComponent
                    },
                    {
                        path: 'shared-docs', data: {
                        breadcrumb: 'Shared Documents'
                    }, component: ConnectSharedDocsComponent
                    },
                    {
                        path: 'referral/:id', data: {
                        breadcrumb: 'Referral'
                    }, component: ReferralFormComponent
                    },
                    {
                        path: 'cirfs', data: {
                        breadcrumb: 'Client Information Form'
                    }, component: CirfHomeComponent,
                        children: [
                            {path: '', redirectTo: 'cirf-home', pathMatch: 'full'},
                            {
                                path: 'cirf-home',data: {breadcrumb: {skip: true}}, component: ConnectCirfClientListComponent
                            },
                            {
                                path: 'form/:id', data: {
                                breadcrumb: 'Personal Details'
                            }, component: ConnectCirfComponent
                            },
                            {
                                path: 'matter-property-info', data: {
                                breadcrumb: 'Transaction Details'
                            }, component: MatterPropertyInfoComponent
                            },
                            {
                                path: 'mortgage-form/:id', data: {
                                breadcrumb: 'Mortgage/Loan Details'
                            }, component: MortgageFormComponent
                            },
                            {path: 'print-cirf',data: {breadcrumb: {label : 'Print'}}, component: PrintCirfComponent}
                        ]
                    }
                ]

            },
            {
                path: 'referral/:id', data: {
                breadcrumb: 'Referral'
                }, component: ReferralFormComponent
            },
            {
                path: 'my-credentials', data: {
                    breadcrumb: 'My Credentials'
                }, component: MyCredentialsComponent
            }


        ]
    },
    indexRoute,
    fallbackRoute
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
